import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';

const locationImages = [
  "/images/british.png",
  "/images/etihad.png",
  "/images/air.png",
  "/images/klm.png",
  "/images/qatar.png",
  "/images/emir.png",
];

const LocationsMarquee = () => {
  const marqueeRef = useRef(null);
  const marqueeTween = useRef(null);

  useEffect(() => {
    // Smooth scrolling marquee animation
    marqueeTween.current = gsap.to(marqueeRef.current, {
      xPercent: -50, // Moves the container by 50% of its width
      duration: 10, // Slower duration for smoother scrolling
      ease: "linear",
      repeat: -1,
      delay: 0.1, // Optional delay before repeat
    });

    return () => {
      marqueeTween.current.kill();
    };
  }, []);

  const handleMouseEnter = () => {
    marqueeTween.current.pause();
  };

  const handleMouseLeave = () => {
    marqueeTween.current.resume();
  };

  return (
    <div 
      className="flex flex-col md:flex-row items-center overflow-hidden text-gray-900 bg-gray-900 py-12"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <h2 className="hidden md:block text-xl md:text-3xl font-bold z-10 relative md:mr-4 md:ml-6 text-white">Key Carriers Include</h2>
      <div className="hidden md:block h-24 w-1 bg-gray-300 mx-4 z-10 relative"></div>
      <h2 className="md:hidden mb-8 text-3xl font-bold z-10 relative text-white">Key Carriers Include</h2>
      <div className="relative flex-1 overflow-hidden">
        <div ref={marqueeRef} className="flex gap-6 md:gap-12 whitespace-nowrap">
          {/* Duplicate images to ensure seamless scrolling */}
          {locationImages.concat(locationImages).map((image, index) => (
            <div key={index} className="flex items-center justify-center">
              <img 
                src={image} 
                alt={`Location ${index + 1}`} 
                className="h-24 w-auto object-contain shadow-md" 
                style={{ maxHeight: '80px', maxWidth: '150px' }}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LocationsMarquee;